const rankingItems = [
  { rank: 1, title: '顶流艺人后台争执录音事件', views: '128.6万', tag: '爆', trend: 'up' },
  { rank: 2, title: '知名MCN机构集体解约风暴', views: '96.3万', tag: '热', trend: 'up' },
  { rank: 3, title: '某综艺节目恶意剪辑内幕', views: '87.1万', tag: '热', trend: 'same' },
  { rank: 4, title: '网红直播数据掺水全揭露', views: '74.5万', tag: 'NEW', trend: 'up' },
  { rank: 5, title: '科技品牌发布会前夕造假', views: '62.8万', tag: 'NEW', trend: 'up' },
];

const timelineItems = [
  { time: '10分钟前', title: '某知名歌手新专辑被曝抄袭海外小众乐队，对比音频已在网络疯传', tag: '最新' },
  { time: '28分钟前', title: '头部主播直播间出现口误，疑似暴露合作品牌内部定价策略', tag: '最新' },
  { time: '1小时前', title: '某影视公司内部邮件泄露，多部待播剧排播计划提前曝光', tag: '热' },
  { time: '2小时前', title: '知名美食博主探店视频被质疑收钱做假评价，评论区已沦陷', tag: '' },
  { time: '3小时前', title: '某电商平台大促数据疑似注水，第三方监测公布真实转化率', tag: '爆' },
  { time: '4小时前', title: '热门综艺选手被前经纪人爆料，合同条款存在严重不平等内容', tag: '' },
  { time: '5小时前', title: '某品牌代言人突然被撤换，知情人透露与近期负面舆情有关', tag: '' },
  { time: '6小时前', title: '知名作家新书陷入代笔争议，多位业内人士出声质疑创作能力', tag: '热' },
  { time: '7小时前', title: '游戏直播圈大地震：某平台被曝拖欠主播工资长达三个月', tag: '' },
];

const topicTags = [
  { tag: '#顶流塌房', count: '128篇', hot: true },
  { tag: '#MCN黑幕', count: '96篇', hot: true },
  { tag: '#直播造假', count: '87篇', hot: true },
  { tag: '#综艺剪辑', count: '74篇', hot: false },
  { tag: '#网红解约', count: '68篇', hot: false },
  { tag: '#品牌翻车', count: '59篇', hot: true },
  { tag: '#数据注水', count: '53篇', hot: false },
  { tag: '#艺人内斗', count: '47篇', hot: false },
  { tag: '#抄袭风波', count: '41篇', hot: true },
];

export default function SectionsC() {
  return (
    <>
      {/* #ranking - 热度榜单 */}
      <section id="ranking" className="relative py-14 md:py-20 bg-background-50">
        <div className="w-full px-4 md:px-6 max-w-[1400px] mx-auto">
          <div className="flex flex-col sm:flex-row sm:items-end justify-between mb-10 md:mb-14 gap-4">
            <div>
              <h2 className="font-heading font-black text-2xl md:text-4xl text-foreground-950 mb-3">
                吃瓜热度榜
              </h2>
              <p className="text-secondary-500 text-sm md:text-base">
                实时更新全网最热黑料事件排名
              </p>
            </div>
            <span className="inline-flex items-center gap-1.5 text-xs text-secondary-400 whitespace-nowrap">
              <span className="w-2 h-2 rounded-full bg-primary-500 animate-pulse"></span>
              实时更新中
            </span>
          </div>

          <div className="bg-background-100 rounded-2xl overflow-hidden">
            {rankingItems.map((item) => (
              <div
                key={item.rank}
                className="flex items-center gap-4 p-4 md:p-5 border-b border-background-200 last:border-b-0 hover:bg-background-50 cursor-pointer transition-colors"
              >
                <div className={`w-9 h-9 rounded-xl flex items-center justify-center font-black text-sm shrink-0 ${
                  item.rank <= 3
                    ? 'bg-primary-500 text-white'
                    : 'bg-secondary-100 text-secondary-500'
                }`}>
                  {item.rank}
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 flex-wrap mb-0.5">
                    <span className="font-heading font-bold text-sm md:text-base text-foreground-900 truncate">
                      {item.title}
                    </span>
                    {item.tag && (
                      <span className="px-2 py-0.5 rounded-full bg-primary-100 text-primary-700 text-[10px] font-bold whitespace-nowrap">
                        {item.tag}
                      </span>
                    )}
                  </div>
                  <span className="text-xs text-secondary-400">{item.views} 阅读</span>
                </div>
                <span className={`text-sm ${item.trend === 'up' ? 'text-primary-500' : 'text-secondary-400'}`}>
                  <i className={`${item.trend === 'up' ? 'ri-arrow-up-line' : 'ri-subtract-line'}`}></i>
                </span>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* #updates - 动态时间线/快讯列表 */}
      <section id="updates" className="relative py-14 md:py-20 bg-background-100">
        <div className="w-full px-4 md:px-6 max-w-[1400px] mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <h2 className="font-heading font-black text-2xl md:text-4xl text-foreground-950 mb-3">
              最新动态
            </h2>
            <p className="text-secondary-500 text-sm md:text-base max-w-xl mx-auto">
              实时追踪全网黑料吃瓜动态，不错过任何一个瓜
            </p>
          </div>

          <div className="max-w-3xl mx-auto relative">
            <div className="absolute left-[19px] top-2 bottom-2 w-0.5 bg-background-300 hidden sm:block"></div>
            <div className="space-y-0">
              {timelineItems.map((item, i) => (
                <div key={i} className="relative flex gap-4 py-3 md:py-4 group cursor-pointer">
                  <div className="hidden sm:flex w-10 shrink-0 items-start justify-center pt-1.5 relative z-10">
                    <div className={`w-2.5 h-2.5 rounded-full border-2 border-background-100 ${
                      i === 0 ? 'bg-primary-500 ring-4 ring-primary-100' :
                      i < 3 ? 'bg-accent-500' : 'bg-secondary-300'
                    }`}></div>
                  </div>
                  <div className="flex-1 min-w-0 bg-background-50 rounded-xl p-4 md:p-5 hover:shadow-md transition-shadow">
                    <div className="flex items-center gap-2 mb-1.5 flex-wrap">
                      <span className="text-xs text-secondary-400 whitespace-nowrap">{item.time}</span>
                      {item.tag && (
                        <span className={`px-2 py-0.5 rounded-full text-[10px] font-bold whitespace-nowrap ${
                          item.tag === '爆' ? 'bg-primary-100 text-primary-700' :
                          item.tag === '最新' ? 'bg-accent-100 text-accent-700' :
                          'bg-secondary-100 text-secondary-700'
                        }`}>
                          {item.tag}
                        </span>
                      )}
                    </div>
                    <p className="text-sm md:text-base text-foreground-800 leading-relaxed group-hover:text-primary-500 transition-colors">
                      {item.title}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* #topics - 话题标签与热度 */}
      <section id="topics" className="relative py-14 md:py-20 bg-background-50">
        <div className="w-full px-4 md:px-6 max-w-[1400px] mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <h2 className="font-heading font-black text-2xl md:text-4xl text-foreground-950 mb-3">
              热门话题
            </h2>
            <p className="text-secondary-500 text-sm md:text-base max-w-xl mx-auto">
              大家都在讨论的黑料话题，点击加入讨论
            </p>
          </div>

          <div className="flex flex-wrap justify-center gap-3 md:gap-4">
            {topicTags.map((t) => (
              <a
                key={t.tag}
                href="#cards"
                onClick={(e) => { e.preventDefault(); document.querySelector('#cards')?.scrollIntoView({ behavior: 'smooth' }); }}
                className={`inline-flex items-center gap-2 px-5 py-3 rounded-full cursor-pointer transition-all whitespace-nowrap ${
                  t.hot
                    ? 'bg-primary-50 text-primary-700 border border-primary-200 hover:bg-primary-100 hover:shadow-md hover:-translate-y-0.5'
                    : 'bg-background-100 text-secondary-500 border border-background-200 hover:bg-background-200 hover:shadow-md hover:-translate-y-0.5'
                }`}
              >
                <span className="text-sm md:text-base font-bold">{t.tag}</span>
                <span className={`text-xs px-2 py-0.5 rounded-full ${
                  t.hot ? 'bg-primary-100 text-primary-600' : 'bg-secondary-200 text-secondary-500'
                }`}>
                  {t.count}
                </span>
              </a>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}